import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type ActionItem = {
  iconName: 'FileText' | 'MessageSquare' | 'Image';
  titleKey: string;
  descKey: string;
};

const ACTION_ITEMS: ActionItem[] = [
  {
    iconName: 'FileText',
    titleKey: 'onBoarding.taskWelcome.joinedGuidance.action1Title',
    descKey: 'onBoarding.taskWelcome.joinedGuidance.action1Desc',
  },
  {
    iconName: 'MessageSquare',
    titleKey: 'onBoarding.taskWelcome.joinedGuidance.action2Title',
    descKey: 'onBoarding.taskWelcome.joinedGuidance.action2Desc',
  },
  {
    iconName: 'Image',
    titleKey: 'onBoarding.taskWelcome.joinedGuidance.action3Title',
    descKey: 'onBoarding.taskWelcome.joinedGuidance.action3Desc',
  },
];

type TaskJoinedGuidanceCardProps = {
  onDismiss: () => void;
};

export const TaskJoinedGuidanceCard: React.FC<TaskJoinedGuidanceCardProps> = ({
  onDismiss,
}) => {
  const { t } = useTranslation('models');

  return (
    <Box
      backgroundColor='grey01'
      borderRadius='s'
      mb='l'
      style={{ overflow: 'hidden' }}>
      {/* Green header */}
      <Box
        backgroundColor='greenSecondaryMild'
        flexDirection='row'
        alignItems='center'
        p='m'
        style={{ gap: theme.spacing.s }}>
        <Box
          width={40}
          height={40}
          backgroundColor='greenSecondary'
          alignItems='center'
          justifyContent='center'
          style={{ borderRadius: 100 }}>
          <Icon name='Check' width={24} height={24} color='white' />
        </Box>
        <Text variant='labelEmphasized' color='textPrimary' flex={1}>
          {t('onBoarding.taskWelcome.joinedGuidance.header')}
        </Text>
      </Box>

      {/* Content */}
      <Box p='m' style={{ gap: theme.spacing.s }}>
        <Text variant='labelEmphasized' color='textPrimary' mb='xxs'>
          {t('onBoarding.taskWelcome.joinedGuidance.subheader')}
        </Text>

        {ACTION_ITEMS.map((item) => (
          <Box
            key={item.iconName}
            backgroundColor='white'
            borderRadius='s'
            borderWidth={1}
            borderColor='grey02'
            flexDirection='row'
            alignItems='center'
            p='m'
            style={{ gap: theme.spacing.s }}>
            <Box
              width={40}
              height={40}
              backgroundColor='greenSecondaryMild'
              alignItems='center'
              justifyContent='center'
              borderRadius='s'>
              <Icon
                name={item.iconName}
                width={20}
                height={20}
                color='greenSecondary'
              />
            </Box>
            <Box flex={1}>
              <Text variant='labelSmall' color='textPrimary' mb='xxxs'>
                {t(item.titleKey)}
              </Text>
              <Text variant='webBodyHintSubline' color='textSecondary'>
                {t(item.descKey)}
              </Text>
            </Box>
          </Box>
        ))}

        <Button
          variant='edit'
          fullWidth
          onPress={onDismiss}
          accessibilityLabel={t('onBoarding.taskWelcome.joinedGuidance.gotIt')}>
          {t('onBoarding.taskWelcome.joinedGuidance.gotIt')}
        </Button>
      </Box>
    </Box>
  );
};
